import client from './client'

export async function fetchSiteOptions() {
  return client.get('/site-options')
}
